var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleEmail = function SvgCircleEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentcolor",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.2 17.4H7.4a2 2 0 0 1-2-2V9.2a2 2 0 0 1 2-2h9.8a2 2 0 0 1 2 2v6.2a2 2 0 0 1-2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M5.4 10.033V9.2a2 2 0 0 1 2-2h9.8a2 2 0 0 1 2 2v.833m-13.8 0V15.4a2 2 0 0 0 2 2h9.8a2 2 0 0 0 2-2v-5.367m-13.8 0 6.016 2.965a2 2 0 0 0 1.768 0l6.016-2.965"
  })));
};
export { SvgCircleEmail as ReactComponent };